const formatAddress = (location) => {
  if (!location) return '';

  const addressCity = [location.address, location.city].filter(Boolean).join(' ');
  const stateZip = [location.state, location.zipcode].filter(Boolean).join(' ');

  return [addressCity, stateZip].filter(Boolean).join(', ');
};
export default formatAddress;
